class Slide extends lm.Composant {
  /**
   * @constructor
   * @param {String} id
   */
  constructor(id) {
    super(id);
    window.addEventListener('keydown', e => {
      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          keyboardNav(this.target, 'prev');
          break;
        case 'ArrowRight':
          e.preventDefault();
          keyboardNav(this.target, 'next');
          break;
        case 'Escape':
          e.preventDefault();
          keyboardNav(this.target, 'close');
          break;
        default:
          return;
      }
    });
    [...this.target.querySelectorAll('.js-cart-add-form')].forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        e.stopPropagation();
        const {
          reflm,
          quantity,
          offerId,
          contextCode
        } = form;
        const event = new CustomEvent('cartUpdate', {
          detail: {
            listProducts: [{
              reflm: reflm.value,
              quantity: parseInt(quantity.value, 10),
              offerId: offerId.value,
              contextCode: contextCode.value
            }]
          }
        });
        document.dispatchEvent(event);
      });
    });
  }
}
function keyboardNav(target, className) {
  if (!target.querySelector(`.js-${className}`).classList.contains('o-controls--hidden')) {
    target.querySelector(`.js-${className}`).click();
  }
}
function initSlide() {
  new Slide('slide');
}
if (document.readyState === 'loading') {
  globalThis.addEventListener('DOMContentLoaded', initSlide);
} else {
  initSlide();
}